import * as React from "react";

import Divider from "../Divider";
import s from "./index.module.scss";
import * as Assets from "../../assets";
import { IMapZoomState } from "./interfaces/IMapZoomState";

interface IZoomControl {
	mapZoomState: IMapZoomState;
	zoomIn: () => void;
	zoomOut: () => void;
}

const ZoomControl = ({ mapZoomState, zoomIn, zoomOut }: IZoomControl) => {
	const onClickZoomIn = (event: any) => {
		!event.preventDefault && event.preventDefault();
		zoomIn();
	};

	const onClickZoomOut = (event: any) => {
		!event.preventDefault && event.preventDefault();
		zoomOut();
	};

	const zoomInStyleClasses = (): string => {
		const classes = [s.zoomControl__button];
		if (mapZoomState.zoom >= mapZoomState.maxZoom) {
			classes.push(s.zoomControl__button_disabled);
		}

		return classes.join(" ");
	};

	const zoomOutStyleClasses = (): string => {
		const classes = [s.zoomControl__button];
		if (mapZoomState.zoom <= mapZoomState.minZoom) {
			classes.push(s.zoomControl__button_disabled);
		}

		return classes.join(" ");
	};

	return (
		<div className={s.zoomControl}>
			<div className={s.zoomControl__column}>
				<div className={zoomInStyleClasses()}>
					<img alt={"plus"} src={Assets.Plus} onClick={onClickZoomIn}/>
				</div>
				<div className={s.zoomControl__divider}>
					<Divider height={1} color={"var(--sw-lightGray-color)"}/>
				</div>
				<div className={zoomOutStyleClasses()}>
					<img alt={"minus"} src={Assets.Minus} onClick={onClickZoomOut}/>
				</div>
			</div>
		</div>
	);
};

export default ZoomControl;
